import React, { Component } from 'react'
import styles from './style.module.less'
import { observer, inject } from 'mobx-react'
import UploadField from '@common/UploadField'
import cls from 'classnames'

@inject('sessionPictureStore')
@observer
export default class extends Component {
  render() {
    const {
      addtext,
      pictureLength,
      uploadPicture,
      checkImageSize,
      pictureLimit
    } = this.props.sessionPictureStore
    return (
      <div className={styles.wrapper}>
        <div className={styles.buttons}>
          <div className={styles.text} onClick={addtext}>
            <img src="//qnm.hunliji.com/FrG4MfcamM5H6NRsfcC22Qf8AGPN" alt="" />
            <div>添加文字</div>
          </div>

          {pictureLength < pictureLimit ? (
            <UploadField
              key={Math.random()}
              multiple={true}
              onOk={uploadPicture}
              onError={(...args) => {
                checkImageSize(...args)
                this.forceUpdate()
              }}
              max_file_size="10mb"
              filters={{
                mime_types: [
                  {
                    title: 'images files',
                    extensions: 'jpg,png,jpeg,bmp'
                  }
                ],
                max_file_size: '10mb',
                prevent_duplicates: true
              }}
            >
              {({ provided }) => (
                <div className={styles.picture} {...provided}>
                  <img
                    src="//qnm.hunliji.com/Flmn0P7fkBSWr0WjKlttyQfemw2P"
                    alt=""
                  />
                  <div>
                    上传图片({pictureLength}/{pictureLimit})
                  </div>
                </div>
              )}
            </UploadField>
          ) : (
            <div className={cls(styles.picture, styles.disabled)}>
              <img
                src="//qnm.hunliji.com/FhubwUINmWrLOTLfZmkXJmEWOyTX"
                alt=""
              />
              <div>
                上传图片({pictureLength}/{pictureLimit})
              </div>
            </div>
          )}
        </div>
        <div className={styles.texts}>
          <div>1. 至少上传 3 张，最多可添加 {pictureLimit} 张；</div>
          <div>2. 图片需高清，不得添加任何文字、水印、 logo 等；</div>
          <div>
            3. 图片高度在 2048 px 以下，大小不能超过 10 MB，支持
            JPG、PNG和BMP等格式。
          </div>
        </div>
      </div>
    )
  }
}
